import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import BackToTop from "./components/BackToTop.js";
import React, { Suspense, useEffect } from "react";
import loadingAnimation from "./images/loadingAnimation.gif";
import { useTranslation } from "react-i18next";
import { Toaster } from "react-hot-toast";

function App() {
  const Home = React.lazy(() => import("./pages/Home.js"));
  const PartnerWithUs = React.lazy(() => import("./pages/PartnerWithUs.js"));
  const WhatWeDo = React.lazy(() => import("./pages/WhatWeDo.js"));
  const VerifyCountryAdmin = React.lazy(() =>
    import("./pages/VerifyCountryAdmin.js")
  );
  const ShopifyAuth = React.lazy(() => import("./pages/ShopifyAuth.js"));
  const { i18n } = useTranslation();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const host = window.location.hostname;
    const hasVisited = localStorage.getItem("visitedStrablSA");

    if (host?.toLowerCase() === "strabl.sa" && !hasVisited) {
      localStorage.setItem("visitedStrablSA", "true");

      i18n.changeLanguage("ar");
      document.documentElement.lang = "ar";
      document.documentElement.dir = "rtl";
    } else {
      const i18nextLng = localStorage.getItem("i18nextLng");
      if (i18nextLng) {
        document.documentElement.lang = i18nextLng;
        document.documentElement.dir = i18nextLng === "ar" ? "rtl" : "ltr";
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const languages = ["", "en", "ar"];

  return (
    <div className="">
      <BackToTop />
      <BrowserRouter>
        <Routes>
          {languages.map((lang) => (
            <Route path={`/${lang}`} key={lang}>
              <Route
                index
                element={
                  <SuspenseComponent>
                    <Home />
                  </SuspenseComponent>
                }
              />

              <Route
                path="get-in-touch"
                element={
                  <SuspenseComponent>
                    <PartnerWithUs />
                  </SuspenseComponent>
                }
              />
              <Route
                path="what-we-do"
                element={
                  <SuspenseComponent>
                    <WhatWeDo />
                  </SuspenseComponent>
                }
              />
              <Route
                path="verify-country-admin/:token"
                element={
                  <SuspenseComponent>
                    <VerifyCountryAdmin />
                  </SuspenseComponent>
                }
              />
              <Route
                path="shopify-auth"
                element={
                  <SuspenseComponent>
                    <ShopifyAuth />
                  </SuspenseComponent>
                }
              />
            </Route>
          ))}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Toaster
          position="bottom-center"
          gutter={5}
          toastOptions={{
            style: {
              backgroundColor: "#100C08",
              color: "#FFFFFF",
              borderRadius: "4px",
              padding: "10px 16px",
              fontSize: "14px",
              fontWeight: "400",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;

function SuspenseComponent({ children }) {
  return (
    <Suspense
      fallback={
        <div className="flex flex-col justify-center items-center h-[80vh]">
          <img
            src={loadingAnimation}
            alt="Processing"
            className="w-28 h-28"
            width={694}
            height={694}
          />
        </div>
      }
    >
      {children}
    </Suspense>
  );
}

function RedirectToBlog() {
  const { pathname } = useLocation();
  const baseUrl = "https://strabl.io";

  useEffect(() => {
    if (pathname.includes(".html")) {
      window.location.href = `${baseUrl}${pathname}`;
    } else {
      // check if pathname ends with slash
      if (pathname.endsWith("/")) {
        window.location.href = `${baseUrl}${pathname}index.html`;
      } else {
        window.location.href = `${baseUrl}${pathname}/index.html`;
      }
    }
  }, [pathname]);

  return (
    <div className="w-full h-screen flex justify-center items-center">
      <h1 className="text-lg font-bold animate-pulse">
        Redirecting to blog...
      </h1>
    </div>
  );
}
